export default {
  getLoading: state => state.loading,
  getDepartments: state => state.departments,
  getErrors: state => state.errors,
  getConfirmationNumber: state => state.confirmationNumber
};